import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  backgroundColor?: string;
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled(motion.div)<{ $size: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${props => props.$size * 2}px; // Ensure enough space for spinner
  width: 100%;
`;

const SpinnerStyled = styled(motion.div)<{ $size: number; $color: string; $backgroundColor: string }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border: 4px solid ${props => props.$backgroundColor};
  border-top: 4px solid ${props => props.$color};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 50, 
  color = '#dc2626', 
  backgroundColor = 'rgba(220, 38, 38, 0.2)' 
}) => {
  return (
    <SpinnerContainer $size={size}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <SpinnerStyled $size={size} $color={color} $backgroundColor={backgroundColor} />
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
